module.exports = __webpack_public_path__ + "static/media/Zoom-Out.77107d5f.svg";